import { createTheme } from "@mui/material";

// Tema personalizado para corresponder ao Garantti
export const garanttiTheme = createTheme({
	palette: {
		primary: {
			main: "#8A2BE2", // Cor roxa do Garantti
			light: "#9D4EE9",
			dark: "#7A1ED0",
			contrastText: "#fff",
		},
		background: {
			default: "#f5f5f7",
			paper: "#ffffff",
		},
		text: {
			primary: "#333333",
			secondary: "#666666",
		},
	},
	typography: {
		fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
		h4: {
			fontWeight: 500,
		},
		h5: {
			fontWeight: 500,
		},
		h6: {
			fontWeight: 500,
		},
		subtitle1: {
			fontWeight: 500,
		},
	},
	shape: {
		borderRadius: 4,
	},
	components: {
		MuiButton: {
			styleOverrides: {
				root: {
					textTransform: "none",
					fontWeight: 500,
					borderRadius: 4,
				},
				containedPrimary: {
					boxShadow: "none",
					"&:hover": {
						boxShadow: "none",
					},
				},
			},
		},
		MuiCard: {
			styleOverrides: {
				root: {
					boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
					borderRadius: 8,
				},
			},
		},
		MuiDivider: {
			styleOverrides: {
				root: {
					backgroundColor: "rgba(0, 0, 0, 0.06)",
				},
			},
		},
	},
});
